import React from "react";
import { useTranslation } from "react-i18next";
import {
  useEditResourceGroup,
  useRetrieveResourceGroup,
} from "@planzone/view-models";
import { Group } from "@planzone/dto";
import { Loader } from "@common/loader";
import { Modal } from "@common/modal";
import { GroupEditionForm } from "./groupEditionForm";
import { Props } from "./types";
import styles from "./styles.scss";

function ResourceGroupEdition({
  group: { uuid, resourceType },
  project,
  cancel,
}: Props) {
  const { t } = useTranslation();
  const {
    group,
    isRequestPending,
    isRequestFailure,
    isRequestSuccess,
    retrieveResourceGroup,
  } = useRetrieveResourceGroup(uuid);
  const { editResourceGroup, isRequestPending: isEditionRequestPending } =
    useEditResourceGroup(group);
  const [formData, setFormData] = React.useState<Group>(group);

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveResourceGroup({ groupId: uuid, resourceType });
  }, [uuid]);

  React.useEffect(() => {
    setFormData(group);
  }, [group]);

  return (
    <Modal
      header={`${t("editResourceGroup.title")} ${group.name}`}
      close={cancel}
    >
      {(isEditionRequestPending || isRequestPending) && (
        <div className={styles.loader}>
          <div className={styles.loaderMain}>
            <Loader />
          </div>
        </div>
      )}
      <form
        onSubmit={(event) => {
          event.preventDefault();
          !isEditionRequestPending &&
            editResourceGroup({ group, nextGroup: formData });
        }}
        className={styles.main}
      >
        <div className={styles.form}>
          <GroupEditionForm
            formData={formData}
            group={group}
            project={project}
            edit={setFormData}
            submit={(formData) =>
              editResourceGroup({
                group,
                nextGroup: formData,
              })
            }
          />
        </div>
      </form>
    </Modal>
  );
}

export { ResourceGroupEdition };
